import { render } from "./MessageView.vue?vue&type=template&id=42b70330&scoped=true"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=42b70330&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b70330"]])

export default __exports__